import './general/startup/hidden-header';
import './general/startup/startup';
import { slideToggle } from './general/startup/slide';
import Modal from './addons/micro-modal';
import './general/mask';
import './general/consultation_v2';
import './general/startup/accessibility-menu';
import './general/startup/usercentrics';

/** NOT FULLY SUPPORTED BY SAFARI therefore ->
 * window.requestIdleCallback()
 * version 0.0.0
 * Browser Compatibility:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback#browser_compatibility
 */
if (!window.requestIdleCallback) {
  window.requestIdleCallback = function (callback, options) {
    const newOptions = options || {};
    const relaxation = 1;
    const timeout = newOptions.timeout || relaxation;
    const start = performance.now();
    return setTimeout(function () {
      callback({
        get didTimeout() {
          return newOptions.timeout ? false : performance.now() - start - relaxation > timeout;
        },
        timeRemaining: function () {
          return Math.max(0, relaxation + (performance.now() - start));
        }
      });
    }, relaxation);
  };
}

// code for styleguide inputs
document.querySelectorAll('.otto-form-element').forEach(element => {
  const field = element.querySelector('.otto-field-wrapper');
  if (!field) {
    return;
  }
  const input = field.querySelector('.otto-field');

  // update disabled and empty classes on wrapper for large inputs
  input.addEventListener('update', () => {
    element.classList.toggle('disabled', input.disabled);
    element.classList.toggle('empty', !input.value);
  });
  input.addEventListener('input', () => {
    element.classList.toggle('empty', !input.value);
  });

  // bouncer error integration
  input.addEventListener('bouncerShowError', () => {
    element.classList.add('error');
  });
  input.addEventListener('bouncerRemoveError', () => {
    element.classList.remove('error');
  });

  input.dispatchEvent(new Event('update'));

  //click on prefix/suffix should focus input too
  field.addEventListener('click', e => {
    if (e.target !== input) {
      input.focus();
    }
  });
});

// Modal

Modal.init({
  onShow: modal => {
    modal.dispatchEvent(new CustomEvent('modalShow'));
  },
  onClose: modal => {
    modal.dispatchEvent(new CustomEvent('modalClose'));
  },
  disableScroll: true,
  openTrigger: 'data-modal',
  closeTrigger: 'data-close'
});

//triggerChat on mobile

document.querySelectorAll('.triggerChat').forEach(elem => {
  elem.addEventListener('click', e => {
    e.preventDefault();
    document.querySelector('body > otto-support-chat').shadowRoot.querySelector('div > otto-support-chat-button').shadowRoot.querySelector('button').click();
    if (!elem.classList.contains('accessibility-chat')) {
      setTimeout(() => {
        document.querySelector('#header .navigation-toggle').click();
      }, 600);
    }
  });
});

// Footer

document.querySelectorAll('#footer .navigation .box nav').forEach(elem => {
  const button = elem.querySelector('button');
  if (!button) {
    return;
  }
  button.addEventListener('click', e => {
    elem.classList.toggle('active');
    slideToggle(elem.querySelector('ul'));
    button.setAttribute('aria-expanded', elem.classList.contains('active'));
  });
});

// File list download icon

document.querySelectorAll('.btn-download').forEach(elem => {
  const svg = elem.querySelector('.dlanim');
  if (typeof svg != 'undefined' && svg != null) {
    elem.addEventListener('click', e => {
      svg.classList.add('loaded');
    });
  }
});

// LOADING CHAT

const chatLoader = timeout => {
  requestIdleCallback(() => {
    setTimeout(() => {
      if (document.querySelector('otto-support-chat')) {
        //MODULE SCRIPT TAG
        const scriptTag = document.createElement('script'); // Create a new script tag
        scriptTag.type = 'module'; // Set the type of the script
        scriptTag.src = '/assets/dist/support-chat/otto-support-chat.esm.js'; // Set the source of the script
        // Add the nonce attribute if available
        const noncedTag = document.querySelector('[nonce]');
        if (noncedTag && noncedTag.nonce) {
          scriptTag.nonce = noncedTag.nonce;
        }
        document.head.appendChild(scriptTag); // Append the script tag to the head

        //NOMUDULE SCRIPT
        const nomoduleTag = document.createElement('script'); // Create a new script tag
        nomoduleTag.nomodule = true; // Set the type of the script
        nomoduleTag.src = '/assets/dist/support-chat/otto-support-chat.js'; // Set the source of the script
        // Add the nonce attribute if available
        if (noncedTag && noncedTag.nonce) {
          nomoduleTag.nonce = noncedTag.nonce;
        }
        document.head.appendChild(nomoduleTag); // Append the script tag to the head
      }
    }, timeout || 300); // Wait for 300ms as default before loading the script
  });
};

// User Interaction Events
const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart']; // The events to listen for

/**
 * Load the interaction script when the user interacts with the page.
 */
const loadInteractionScript = () => {
  activityEvents.forEach(event => document.removeEventListener(event, loadInteractionScript)); // Remove the event listeners
  chatLoader(300); //load chat on idle after 600ms
};

// Add event listeners for user interaction events
activityEvents.forEach(event => document.addEventListener(event, loadInteractionScript));

// Welcome

const is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
const is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome/') > -1;

if (window.innerWidth > 993 && (!is_safari || is_chrome)) {
  console.log(
    '╔══════════════════════════════════════════════════════════════════════════╗\n║..WELCOME TO .............................................................║\n║..██████╗.████████╗████████╗.██████╗.███╗...██╗.██████╗.██╗...██╗.█████╗..║\n║.██╔═══██╗╚══██╔══╝╚══██╔══╝██╔═══██╗████╗..██║██╔═══██╗██║...██║██╔══██╗.║\n║.██║...██║...██║......██║...██║...██║██╔██╗.██║██║...██║██║...██║███████║.║\n║.██║...██║...██║......██║...██║...██║██║╚██╗██║██║...██║╚██╗.██╔╝██╔══██║.║\n║.╚██████╔╝...██║......██║...╚██████╔╝██║.╚████║╚██████╔╝.╚████╔╝.██║..██║.║\n║..╚═════╝....╚═╝......╚═╝....╚═════╝.╚═╝..╚═══╝.╚═════╝...╚═══╝..╚═╝..╚═╝.║\n║....................................OTTONOVA.TECH WISHES A PLEASANT STAY..║\n╚══════════════════════════════════════════════════════════════════════════╝'
  );
} else {
  console.log('════ WELCOME TO OTTONOVA.TECH ════');
}

// Usercentrics
if (window.location.href.indexOf('ottonova.de') > 0 || window.location.href.indexOf('loaduc=1') > 0 || sessionStorage.getItem('loaduc') === 'true') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.uc-privacy-setting').forEach(elem => {
      elem.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
        __ucCmp.showSecondLayer();
      });
    });
  });
}
